import { PaletteOptions } from "@mui/material";

export const WHITE = "#fff";
export const BLACK = "rgba(0, 0, 0, 0.87)";

export const GRAY_LIGHT = "#e0e0e0";
export const GRAY_MAIN = "#8d8d8d";
export const GRAY_DARK = "#8d8d8d";
export const GRAY_LIGHT_RGB_BORDER = "rgb(211, 211, 211, 0.4)"

export const GREEN_LIGHT = "#def7f2";
export const GREEN_MAIN = "#064328";
export const GREEN_DARK = "darkgreen";
export const GREEN_LOGO = "#167047";

export const BLUE_LIGHT = "#0077ff";
export const BLUE_MAIN = "#0a52c6";
export const BLUE_DARK = "#172178";
export const BLUE_LIGHT_RGB_BORDER = "rgb(135, 206, 250, 0.4)"

export const palette: PaletteOptions = {
	mode: "light",
	text:{
		primary: BLACK
	},
	primary: {
		main: BLUE_LIGHT,
		light: BLUE_MAIN,
		dark: BLUE_DARK,
	},
	secondary: {
		main: GREEN_MAIN,
		light: GREEN_LIGHT,
		dark: GREEN_DARK,
	},
	background: {
		default: BLUE_MAIN,
		paper: WHITE,
	},
	success: {
		main: "#00f2c3",
	},
};
